'use strict';

/**
 * Display error messages and highlight form fields with errors.
 * @param {string} parentSelector - the form which contains the fields
 * @param {Object} fieldErrors - the fields with errors
 */
function loadFormErrors(parentSelector, fieldErrors, hide) { // eslint-disable-line
    // Display error messages and highlight form fields with errors.
    $.each(fieldErrors, function (attr) {
        let item = $('*[name=' + attr + ']', parentSelector).addClass('is-invalid').siblings('.invalid-feedback');
        if (item.length === 0) {
            item = $('*[name=' + attr + ']', parentSelector).parent().siblings('.invalid-feedback');
        }
        if (!hide) {
            item.html(fieldErrors[attr]);
            item.show();
        }
    });
    if (!hide && fieldErrors) {
        let item = $(`*[name="${Object.keys(fieldErrors)[0]}"]`, parentSelector);
        item.trigger('focus');

        $('html, body').animate({
            scrollTop: item.offset().top - 150
        }, 500, 'linear');
    }
}

/**
 * Clear the form errors.
 * @param {string} parentSelector - the parent form selector.
 */
function clearPreviousErrors (parentSelector) {
    $(parentSelector).find('.form-control.is-invalid').removeClass('is-invalid');
    $('.error-message').hide();
    $(parentSelector).find('.invalid-feedback').hide();
}

module.exports = {
    loadFormErrors: loadFormErrors,
    clearPreviousErrors: clearPreviousErrors
};

